module.exports = __webpack_public_path__ + "static/media/carousel-5.9b77304e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel-5.jpg
// module id = 148
// module chunks = 1